import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import MuiCard from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { styled } from "@mui/material/styles";
import Collapse from "@mui/material/Collapse";
import AmountClientByInterval from "./AmountClientByInterval";
import Skeleton from "../../../Kit/Skeleton/SkeletonCard";
import TransitionAlerts from "../../../Alert/TransitionAlerts.js";
import { useAuth } from "../../../Auth/AuthProtecter";

const dataSke = [
  {
    id: 1,
  },
  {
    id: 2,
  },
  {
    id: 3,
  },
];

const Card = styled(MuiCard)(({ theme }) => ({
  border: "1px solid",
  borderColor: (theme.vars || theme).palette.divider,
  width: "100%",
  "&:hover": {
    background:
      "linear-gradient(to bottom right, hsla(210, 100%, 97%, 0.5) 25%, hsla(210, 100%, 90%, 0.3) 100%)",
    borderColor: "primary.light",
    boxShadow: "0px 2px 8px hsla(0, 0%, 0%, 0.1)",
    ...theme.applyStyles("dark", {
      background:
        "linear-gradient(to right bottom, hsla(210, 100%, 12%, 0.2) 25%, hsla(210, 100%, 16%, 0.2) 100%)",
      borderColor: "primary.dark",
      boxShadow: "0px 1px 8px hsla(210, 100%, 25%, 0.5) ",
    }),
  },
  [theme.breakpoints.up("md")]: {
    flexGrow: 1,
    maxWidth: `calc(50% - ${theme.spacing(1)})`,
  },
  variants: [
    {
      props: ({ selected }) => selected,
      style: {
        borderColor: (theme.vars || theme).palette.primary.light,
        ...theme.applyStyles("dark", {
          borderColor: (theme.vars || theme).palette.primary.dark,
        }),
      },
    },
  ],
}));

const LST = process.env.REACT_APP_API_FRRS_LSTOREGE;
const secretKey = process.env.REACT_APP_SECRET_KEY_LOCALSTORAGE;
const loct = process.env.REACT_APP_API_AVAILAPMENTBYHOUR;

export default function AvailaptmentByHour({ ...other }) {
  //
  const auth = useAuth();
  //
  const [Url, setLoginUrl] = React.useState(auth.Domain);
  //
  //
  const bytes = CryptoJS.AES.decrypt(sessionStorage.getItem(LST), secretKey);
  const { stat, sucur, fech } = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  //

  const [paymentType, setPaymentType] = useState("creditCard");
  const [OptLoc, setOptLoc] = useState(null);
  const [amountClient, setAmountClient] = useState(false);

  const [messenger, setMessenger] = useState("");
  const [severity, setSeverity] = useState("");
  const [transitionAlerts, setTransitionAlerts] = useState(false);

  const handlePaymentTypeChange = (event) => {
    setPaymentType(event.target.value);
  };

  const handleNext = (hr) => {
    const loct = { stat, sucur, fech };
    const state = { ...loct, hr };

    sessionStorage.setItem(
      LST,
      CryptoJS.AES.encrypt(JSON.stringify(state), secretKey).toString()
    );

    setAmountClient(true);
    //  other.setActiveStep(other.activeStep + 1);
  };

  useEffect(() => {
    const fetchResource = async () => {
      const datePost = {
        idlocation: Number(sucur.id),
        date: fech.fecha,
      };
      //
      try {
        //
        //
        const jsonpass = {
          method: "POST",
          body: JSON.stringify(datePost),
        };
        //
        const respass = await fetch(`${Url}${loct}`, jsonpass);
        //
        const res_pass = await respass.json();
        console.log(respass);
        console.log(res_pass);
        //
        if (respass.status === 200) {
          setOptLoc(res_pass);
        } else if (respass.status === 404) {
          setOptLoc(null);
          setMessenger("¡No hay disponibilidad de venta!");
          setSeverity("warning");
          setTransitionAlerts(true);
        } else {
          setOptLoc(null);
          setMessenger("¡Ocurrio un error, intente nuevamente!");
          setSeverity("error");
          setTransitionAlerts(true);
        }
        //
      } catch (error) {
        //
        console.log(error);
        //
      }
    };
    fetchResource();
  }, []);

  return (
    <>
      <Stack spacing={{ xs: 3, sm: 6 }}>
        <Collapse in={!amountClient}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h6" gutterBottom>
              <Chip label={`🗺️ ${stat.name}`} />/
              <Chip label={`📍 ${sucur.name}`} />/
              <Chip label={`📅 ${fech.fecha}`} />/ Seleccione la hora
            </Typography>
          </Box>
          <FormControl component="fieldset" fullWidth>
            <RadioGroup
              aria-label="Payment options"
              name="paymentType"
              value={paymentType}
              onChange={handlePaymentTypeChange}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
              }}
            >
              {OptLoc ? (
                OptLoc.map((label, i) => (
                  <Card key={i}>
                    <CardActionArea
                      onClick={() => handleNext(label)}
                      sx={{
                        ".MuiCardActionArea-focusHighlight": {
                          backgroundColor: "transparent",
                        },
                        "&:focus-visible": {
                          backgroundColor: "action.hover",
                        },
                      }}
                    >
                      <CardContent
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        🕗
                        <Typography sx={{ fontWeight: "medium" }}>
                          {label.hora}{" "}
                        </Typography>
                        <PeopleAltIcon
                          fontSize="small"
                          sx={[
                            (theme) => ({
                              color: "grey.400",
                              ...theme.applyStyles("dark", {
                                color: "grey.600",
                              }),
                            }),
                            paymentType === "creditCard" && {
                              color: "primary.main",
                            },
                          ]}
                        />
                        <Typography sx={{ fontWeight: "medium" }}>
                          {label.capacidaddisponible}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                ))
              ) : transitionAlerts ? (

                
                
                
                <TransitionAlerts
                  messenger={messenger}
                  severity={severity}
                  open={transitionAlerts}
                />





              ) : (
                dataSke.map((da, i) => (
                  <Card key={da.id}>
                    <Skeleton key={da.id} />
                  </Card>
                ))
              )}
            </RadioGroup>
          </FormControl>
        </Collapse>
      </Stack>
      {amountClient && (
        <Collapse in={amountClient}>
          <AmountClientByInterval
            activeStep={other.activeStep}
            setActiveStep={other.setActiveStep}
            handleNext={other.handleNext}
          />
        </Collapse>
      )}{" "}
    </>
  );
}
